import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { AnalyticsHandlerRegistrant } from '../analytics';
import { useSegment } from './segment-provider';
import { trackEventToSegment } from './track-event';
import { contextToOptions } from './context-to-options';
import { jsx as _jsx } from "react/jsx-runtime";
export const SegmentAnalyticsHandler = () => {
  const segment = useSegment();
  const handler = useMemo(() => ({
    async setUserId(userId) {
      const user = await (segment === null || segment === void 0 ? void 0 : segment.user());
      if (userId) {
        if (user && userId === user.id()) {
          return;
        }
        await (segment === null || segment === void 0 ? void 0 : segment.identify(userId));
      } else {
        if (!user) {
          return;
        }
        const currentId = user.id();
        if (currentId) {
          await (segment === null || segment === void 0 ? void 0 : segment.reset());
        }
      }
    },
    async trackEvent(event) {
      if (segment) {
        await trackEventToSegment(segment, event);
      }
    },
    async trackPage() {
      await (segment === null || segment === void 0 ? void 0 : segment.page('Content', document.title, {
        label: 'page_viewed'
      }, contextToOptions({
        version: 1
      })));
    }
  }), [segment]);
  return /*#__PURE__*/_jsx(AnalyticsHandlerRegistrant, _objectSpread(_objectSpread({}, handler), {}, {
    "data-id": "analytics-segment_analytics-handler_SegmentAnalyticsHandler_AnalyticsHandlerRegistrant"
  }));
};